module.exports = "<my-dispatch-display my-dispatch=\"$$dispatch.data.myDispatch\"\n  enable-back=\"true\">\n</my-dispatch-display>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/dispatch/templates/details.html
// module id = 1495
// module chunks = 0